module.exports = __webpack_public_path__ + "static/negx-35034574e114423babdea92b6a2eb97a.jpg";